export default class PrescriptionModelReference {
  identifier: Identifier;
  version: number;

  constructor(identifier: Identifier, version: number) {
    this.identifier = identifier;
    this.version = version;
  }

  static fromApi({ identifier, version }: PrescriptionModelApi): PrescriptionModelReference {
    return new PrescriptionModelReference(
      identifierFromString(identifier),
      versionFromString(version)
    );
  }

  toApi(): PrescriptionModelApi {
    return {
      identifier: this.identifier,
      version: versionToString(this.version),
    };
  }
}

export enum Identifier {
  MultiLayerSeedingModel = 'MultiLayerSeedingModel',
}

type PrescriptionModelApi = {
  identifier: string;
  version: string;
};

const identifierFromString = (identifier: string): Identifier => {
  switch (identifier) {
    case Identifier.MultiLayerSeedingModel:
      return Identifier.MultiLayerSeedingModel;
    default:
      throw new Error(`Unknown prescription model identifier: ${identifier}`);
  }
};

const versionFromString = (version: string): number => {
  const trimmedVersion = version.trim();
  const match = /^v(\d+)$/i.exec(trimmedVersion);

  if (match) {
    return Number(match[1]);
  }

  const parsedVersion = Number(trimmedVersion);

  if (!Number.isFinite(parsedVersion)) {
    throw new Error(`Invalid prescription model version: ${version}`);
  }

  return parsedVersion;
};

const versionToString = (version: number): string => {
  return `v${version}`;
};
